import { CSSProperties } from 'react';
import classnames from 'classnames';

import { BaseFileTypeDto } from '@eva/types/dto';

// eslint-disable-next-line import/no-cycle
import { FileTypeOption, FileTypeOptionGroup } from './functions';

const groupStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: '10px',
};

const groupBadgeStyle: Partial<CSSProperties> = {
  backgroundColor: '#1088E2',
  borderRadius: '2em',
  color: '#ffffff',
  display: 'inline-block',
  fontSize: '11px',
  fontWeight: 'normal',
  lineHeight: '1',
  minWidth: 1,
  padding: '0.16666666666667em 0.5em',
  textAlign: 'center',
};

export const formatGroupLabel = <FT extends BaseFileTypeDto>(group: FileTypeOptionGroup<FT>) => (
  <div className="font-weight-bold" style={groupStyle}>
    <label className="control-label no-padding">{group.label}</label>
    <span style={groupBadgeStyle}>{group.options.length}</span>
  </div>
);

export const formatFileTypeLabel = <FT extends BaseFileTypeDto>(option: FileTypeOption<FT>) => {
  const classNames = classnames({
    'text-muted': option?.payload?.disabled,
  });

  return (
    <div className={classNames}>
      <span>{option.label}</span>
    </div>
  );
};
